import { styled } from '@material-ui/core/styles';

export const Container = styled('div')(({ theme }) => ({
  height: '600px',
  maxWidth: 1280,
  margin: '6rem auto 0',
  display: 'flex',
  justifyContent: 'space-between',
  gap: '2rem',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    height: 'auto',
    flexDirection: 'column',
  },
  [theme.breakpoints.down('xs')]: {
    paddingTop: '3rem',
  },
}));

export const Info = styled('div')(({ theme }) => ({
  width: '70%',
  '& div': {
    width: '86%',
    marginTop: '15px',
  },
  [theme.breakpoints.down('lg')]: {
    width: '50%',
  },
  [theme.breakpoints.down('md')]: {
    width: '60%',
    '& div': {
      width: '100%',
    },
  },
  [theme.breakpoints.down('sm')]: {
    paddingLeft: '1rem',
    paddingRight: '1rem',
    textAlign: 'center',
    marginTop: '25px',
    width: '80%',
  },
  [theme.breakpoints.down('xs')]: {
    width: '100%',
    marginTop: '25px',
    '& strong': {
      fontWeight: 400,
    },
  },
}));

export const Divider = styled('hr')(({ theme }) => ({
  width: '10%',
  margin: '10px 5px',
  border: `1px solid ${theme.palette.primary.main}`,
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const Image = styled('img')(({ theme }) => ({
  height: '100%',

  [theme.breakpoints.down('md')]: {
    height: '400px',
    marginBottom: '25px',
    backgroundPositionX: 'center',
  },
}));
